<template>
  <v-dialog v-model="isActive" persistent scrollable max-width="500">
    <v-card>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        rounded
        height="6"
      ></v-progress-linear>

      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Detalles

            <v-spacer></v-spacer>

            <v-btn
            class="mr-2"
            outlined
            color="indigo"
            @click.stop="getNumber('trnsf')"
            >
            Transferir
          </v-btn>

          <v-btn
            outlined
            color="error"
            @click.stop="handleCall('hangup')"
          >
            Colgar
          </v-btn>
        </v-card-title>
        </v-img>
      </v-card-title>

      <vuescroll
        :ops="{
          bar: { background: '#bacfcec0', keepShow: true }
        }"
      >
        <v-card-text style="max-height: 350px">
          <v-card flat color="grey lighten-4" v-if="isHandleAction">
            <v-card-text>
              <ValidationObserver>
                <ValidationProvider
                  name="número de teléfono"
                  rules="required"
                  v-slot="{ errors }"
                >
                <p>Indique el número de teléfono a transferir</p>
                  <v-text-field
                    v-model="numberPhone"
                    :error-messages="errors"
                    label="Número de teléfono"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-text-field>
                </ValidationProvider>

                <v-btn
                  :disabled="numberPhone == ''"
                  block
                  x-large
                  class="mr-2 shadow-4"
                  color="success"
                  @click.stop="handleCall()"
                  >
                  Transferir llamada
                </v-btn>
              </ValidationObserver>
            </v-card-text>
          </v-card>

          <br>

          <p v-if="extensionDetails.length == 0">
            Esta extensión no posee agentes asignados.
          </p>

          <div v-else>
            <!-- {{ extensionDetails }} -->
            <v-list-item v-for="(item, index) in extensionDetails" :key="index">
              <v-list-item-avatar>
                <v-icon class="grey lighten-1" dark>
                  mdi-account
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>

                <v-list-item-subtitle
                  v-text="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <!-- <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
              </v-list-item-action> -->
            </v-list-item>
          </div>
        </v-card-text>
      </vuescroll>

      <v-divider></v-divider>

      <v-card-actions class="mx-2">
        <!-- <v-btn
          text
          rounded
          class="mr-1"
          color="error"
          @click="finishCall(item.id)"
        >
          Terminar
        </v-btn> -->

        <v-spacer></v-spacer>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closedialog('cerrar')"
            >Cerrar</v-btn
          >
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";

export default {
  components: {
    vuescroll
  },

  props: ["isActive", "extension", "dataCall"],

  data() {
    return {
      isLoading: false,
      isHandleAction: false,
      actionToDo: "",
      numberPhone: "",
      extensionDetails: []
    };
  },

  created() {
    this.getExtensionDetails();
  },

  methods: {
    closedialog() {
      this.$emit("close:dialog");
    },
    
    async finishCall(value) {
      await PbxHttpClient.get(`/user/end_call/${value}`)
      .then((res) => {
        this.$emit("close:dialog");
      })
      .catch((error) => {
        // console.error(error);
        this.$snotify.error("No se pudo finalizar llamada.", "Error");
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    
    getNumber() {
      this.isHandleAction = true;
      // this.actionToDo = value;
    },

    async handleCall(value = 'trnsf') {
      this.actionToDo = value;
      let payload = {
          ext: this.extension,
          type: this.actionToDo,
          // id_task: null,
        };

        // console.log("hangup", payload)
        
        if(value == 'trnsf') {
          payload.dst = this.numberPhone;
          payload.call_number = this.dataCall.dst;
        }
        // console.log("transfer", payload)

        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `¿Está seguro de ${value == 'trnsf' ? 'transferir' : 'colgar'} la llamada?`
        );
        if (confirmRequest.isConfirmed) {
          await PbxHttpClient.post(`/call_now_crm/`, payload)
            .then((res) => {
              // this.$emit("close:dialog");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error("No se pudo realizar acción.", "Error");
            })
            .finally(() => {
              this.isLoading = false;
              this.closedialog('cerrar');
            });
        }

    },

    async getExtensionDetails() {
      this.isLoading = true;

      await PbxHttpClient.get(`/user/search_ext/${this.extension}`)
        .then((res) => {
          this.extensionDetails = res.data;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
